<template>
  <div class="graphics">
    <canvas class="canvas" id="five"></canvas>
    <div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">Función desempeñada</th>
            <th scope="col" colspan="2">Mujeres</th>
            <th scope="col" colspan="2">Hombres</th>
            <th scope="col" colspan="2">Total</th>
          </tr>
          <tr>
            <th scope="col"></th>
            <th scope="col">N°</th>
            <th scope="col">%</th>
            <th scope="col">N°</th>
            <th scope="col">%</th>
            <th scope="col">N°</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, items) in items" :key="items">
            <th scope="row">{{ item.tipo }}</th>
            <td>{{ item.total_M }}</td>
            <td>
              <span v-if="item.porcentajeH">{{ formattedNumber(item.porcentajeM) }}</span>
              <span v-else>{{ formattedNumber(item.porcentaje_M) }}</span>
            </td>
            <td>{{ item.total_H }}</td>
            <td>
              <span v-if="item.porcentajeH">{{ formattedNumber(item.porcentajeH) }}</span>
              <span v-else>{{ formattedNumber(item.porcentaje_M) }}</span>
            </td>
            <td>{{ formattedNumber(item.total) }}</td>
          </tr>

          <!-- <tr>
            <th scope="row">Total Honorarios</th>
            <td>{{ datos.personalHonorariosFuncion[3].totalDotacionM }}</td>
            <td>100%</td>
            <td>{{ datos.personalHonorariosFuncion[3].totalDotacionH }}</td>
            <td>100%</td>
            <td>{{ datos.personalHonorariosFuncion[3].totalDotacion }}</td>
          </tr>
          <tr v-if="1===2">
            <th scope="row">Porcentaje</th>
            <td>{{ datos.personalHonorariosFuncion[3].porcentajeTotalM }}%</td>
            <td></td>
            <td>{{ datos.personalHonorariosFuncion[3].porcentajeTotalH }}%</td>
            <td></td>
            <td></td>
          </tr> -->
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);

export default {
  name: "PlanetChart",
  props: ["datos"],
  data() {
    return {
      img: "",
      label: [],
      items: null,
      hombres: [],
      mujeres: [],
      total_d: [],
      graphicData: null,
      myChart: null,
    };
  },

  watch: {
    datos: async function() {
      this.datos.personalHonorariosFuncion.map((o) => {
        this.label.push(o.tipo);
        this.hombres.push(o.total_H);
        this.mujeres.push(o.total_M);
        this.total_d.push(o.total);
      });
      await this.graficas();
    },
  },

  methods: {
    graficas: function() {
      var ctx = document.getElementById("five").getContext("2d");
      if (this.myChart) {
        this.myChart.destroy();
      }
      this.myChart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: this.label,
          datasets: [
            {
              label: "Hombres",
              data: this.hombres,
              backgroundColor: ["#2ECC71", "#2ECC71"],
              borderColor: ["#2ECC71", "#2ECC71"],
              barThickness: 20,
            },
            {
              label: "Mujeres",
              data: this.mujeres,
              backgroundColor: ["#770BAA", "#770BAA"],
              borderColor: ["#770BAA", "#770BAA"],
              barThickness: 20,
            },
            {
              label: "Total Dotación ",
              data: this.total_d,
              backgroundColor: ["#EFEFEF"],
              borderColor: ["#EFEFEF"],
              barThickness: 20,
            },
          ],
        },
        options: {
          scales: {
            x: {
              title: {
                display: true,
                text: "Relación Laboral",
                font: {
                  weight: "bold",
                },
              },
              grid: {
                display: false,
              },
            },
            y: {
              max: this.highestValue,
              display: true,
              title: {
                display: true,
                text: "Personas",
                font: {
                  weight: "bold",
                },
              },
            },
          },
          plugins: {
            legend: {
              display: true,
              position: "bottom",
            },
            tooltip: {},
          },
        },

        responsive: true,
        plugins: {
          legend: {
            position: "right",
          },
        },
      });
    },
     formattedNumber: function(value) {
      return new Intl.NumberFormat("de-DE").format(value);
    },
  },
  mounted() {
    setTimeout(() => {
      this.items = this.datos.personalHonorariosFuncion;
    }, 6000);
  },
};
</script>

<style scoped>
.graphics {
  width: 100%;
}
.canvas {
  font-size: 14px;
  color: #052333;
}

th {
  text-align: left !important;
}

td {
  text-align: left !important;
}
</style>
